import { AsText } from '../text-and-lang/as-text.js';
import styleText from './as-param-group.css?raw';

export class AsParamGroup extends HTMLElement {
  static readonly tag = 'as-param-group' as const;

  static get observedAttributes() {
    return ['subheading-default-text', 'subheading-dict-key', 'subheading-vars'];
  }

  private static readonly _sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      AsParamGroup._sheet
    ];
    
    this.shadowRoot!.innerHTML = /*html*/`
      <div class="header">
        <h3 class="subheading"></h3>
      </div>
      <div class="content">
        <slot></slot>
      </div>
    `;
  }

  connectedCallback() {
    this._updateSubheading();
  }

  attributeChangedCallback(name: string, _oldValue: string, _newValue: string) {
    if (['subheading-default-text', 'subheading-dict-key', 'subheading-vars'].includes(name)) {
      this._updateSubheading();
    }
  }

  private _updateSubheading() {
    const subheadingElement = this.shadowRoot?.querySelector('.subheading');
    if (!subheadingElement) return;

    const dictKey = this.getAttribute('subheading-dict-key');
    const defaultText = this.getAttribute('subheading-default-text');

    subheadingElement.innerHTML = '';

    if (dictKey || defaultText) {
      const asText = document.createElement('as-text') as AsText;

      // JSON array for {N} substitution in the localized heading; set before
      // dict-key so the vars are in place when the key subscription registers.
      const vars = this.getAttribute('subheading-vars');
      if (vars) {
        asText.setAttribute('vars', vars);
      }
      if (dictKey) {
        asText.setAttribute('dict-key', dictKey);
      }
      if (defaultText) {
        asText.textContent = defaultText;
      }

      subheadingElement.appendChild(asText);
    }
  }
}

if (!customElements.get(AsParamGroup.tag)) {
  customElements.define(AsParamGroup.tag, AsParamGroup);
} else {
  console.warn('as-param-group already defined');
}
